import { Room } from '../../../Constants';
import { getRoomName } from './TextureTools';

const ROBOTS_REQUIRED = [ null,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1,
    3, 3, 3, 3, 3, 3,
    1, 0, 1, 2 ];

export function is_room_activated(station, station_location_id, robot_assignments) {
    let room_id = station[station_location_id];
    let robots_required = ROBOTS_REQUIRED[room_id];
    let assigned_robots = [];
    robot_assignments.forEach((robot_assignment, robot_id) => {
        if (robot_assignment === station_location_id) {
            assigned_robots.push(robot_id);
        }
    });
    let result = assigned_robots.length === robots_required;
    return result;
}


export function isRoomActivated(gamePlayerData, stationIndex) {
    return is_room_activated(
        gamePlayerData.station,
        stationIndex,
        gamePlayerData.robot_assignments)
}

export function availableStaff(gamePlayerData) {
    return gamePlayerData.robot_storage.filter(staffId => staffId != null);
}


export function canIActivateThisRoom(gamePlayerData, stationIndex) {
    const isAlready = is_room_activated(
        gamePlayerData.station,
        stationIndex,
        gamePlayerData.robot_assignments);
    if (isAlready) return false;
    const roomId = gamePlayerData.station[stationIndex];
    const staffRequired = Room.ROBOTS_REQUIRED[roomId];
    let available = availableStaff(gamePlayerData).length;
    return available >= staffRequired;
}

export function activatedRooms(gamePlayerData) {
    return Array.from(new Set(gamePlayerData.robot_assignments.filter(stationIndex => stationIndex != null)));
}

export function unlockedActivatedStationIndexes(gamePlayerData) {
    return activatedRooms(gamePlayerData).filter(stationIndex => !gamePlayerData.locked_rooms.includes(stationIndex));
}


export function deactivateAllRooms(gamePlayerController) {
    /**
     * One action for each deactivation.
     * Locked rooms do not count.
     */
    let station, robotAssignments, lockedRooms;
    station = gamePlayerController.gamePlayerData.station;
    robotAssignments = gamePlayerController.gamePlayerData.robot_assignments;
    lockedRooms = gamePlayerController.gamePlayerData.locked_rooms;
    let activated = [];
    station.forEach((roomId, stationIndex) => {
        if (robotAssignments.includes(stationIndex) && !activated.includes(stationIndex) && !lockedRooms.includes(stationIndex)) {
            activated.push(stationIndex);
        }
    });
    if (activated.length) {

        // activated.forEach((stationIndex) => {
        gamePlayerController.gamePlayerApi.toggleActivation(activated.pop());
        // });
    }

}


export function open_inner_orbits(orbits) {
    let available_orbits = [];
    let innerOrbits = [0, 1, 2, 3, 4, 5];
    innerOrbits.forEach((orbitIndex) => {
        if (!orbits[orbitIndex]) available_orbits.push(orbitIndex);
    })
    return available_orbits
}

export function available_guest_orbits(orbits) {
    let available_orbits = [];
    orbits.forEach((card, orbit_id) => {
        if (card) {
            if (orbit_id < 6) {
                let outer_card = orbits[orbit_id + 6];
                if (outer_card) return;
            }
            available_orbits.push(orbit_id);
        }
    })
    return available_orbits
}

export function renovationDestinations(gamePlayerData) {
    let result = [];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (!roomId || Room.BUILT_IN_ROOMS.includes(roomId)) {
            if (!gamePlayerData.locked_rooms.includes(stationIndex)) {
                result.push(stationIndex);
            }
        }
    })
    return result
}

export function removableRooms(gamePlayerData) {
    let result = [];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (roomId &&
            !Room.BUILT_IN_ROOMS.includes(roomId) &&
            !gamePlayerData.locked_rooms.includes(stationIndex)) {
            result.push(stationIndex);
        }
    });
    return result;
}

export function sellableRoomsByRenovation(gamePlayerData) {
    let stationIndexes = [];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (roomId &&
            !gamePlayerData.locked_rooms.includes(stationIndex) &&
            (Room.UPGRADED_AMENITY_IDS.includes(roomId) ||
                Room.UPGRADED_BED_IDS.includes(roomId))
        ) {
            stationIndexes.push(stationIndex);
        }
    });
    return stationIndexes;
}

export function installableStorageIndexes(gamePlayerData) {
    let storageIndexes = [];
    gamePlayerData.storage.forEach(
        (roomId, index) => {
            if (roomId) storageIndexes.push(index);
        }
    );
    return storageIndexes;
}

export function matchingActionRooms(gamePlayerData, actionId) {
    const matchingActionRoomTypes = Room.ACTION_ROOM_TYPES[actionId];
    let indexes = [];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (!roomId) {
            return;
        }
        if (matchingActionRoomTypes.includes(roomId)) {
            indexes.push(
                {
                    stationIndex: stationIndex,
                    name: getRoomName(roomId),
                    activated: is_room_activated(
                        gamePlayerData.station,
                        stationIndex,
                        gamePlayerData.robot_assignments)
                });
        }
    });
    return indexes;
}

export function activateMatchingActionRooms(
        gamePlayerController, actionId) {
    const matchingActionRoomTypes = Room.ACTION_ROOM_TYPES[actionId];
    gamePlayerController.gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (!roomId) {
            return;
        }
        if (matchingActionRoomTypes.includes(roomId)) {
            gamePlayerController.toggleActivation(stationIndex);
        }
    });
}

export function activateABed(gamePlayerController) {
    let success = false;
    for (const [stationIndex, roomId] of gamePlayerController.gamePlayerData.station.entries()) {
        if (roomId && Room.FACTION_BEDS.includes(roomId) &&
            !isRoomActivated(gamePlayerController.gamePlayerData, stationIndex) &&
            canIActivateThisRoom(gamePlayerController.gamePlayerData, stationIndex)
        ){
                gamePlayerController.gamePlayerApi.toggleActivation(stationIndex);
                success = true;
                break;
        }
    }
    if (success) return success;
    for (const [stationIndex, roomId] of gamePlayerController.gamePlayerData.station.entries()) {
        if (roomId && Room.BED_IDS.includes(roomId) &&
            !isRoomActivated(gamePlayerController.gamePlayerData, stationIndex) &&
            canIActivateThisRoom(gamePlayerController.gamePlayerData, stationIndex)
        ){
            gamePlayerController.gamePlayerApi.toggleActivation(stationIndex);
            success = true;
            break;
        }
    }
    return success;
}


export function activateAnAmenity(gamePlayerController) {
    const matchingActionRoomTypes = Room.AMENITY_IDS;
    let success = false;
    for (const [stationIndex, roomId] of gamePlayerController.gamePlayerData.station.entries()) {
        if (roomId && matchingActionRoomTypes.includes(roomId) &&
            !isRoomActivated(gamePlayerController.gamePlayerData, stationIndex) &&
            canIActivateThisRoom(gamePlayerController.gamePlayerData, stationIndex)
        ){
            gamePlayerController.gamePlayerApi.toggleActivation(stationIndex);
            success = true;
            break;
        }
    }
    return success;
}

export function canIActivateABedOrAmenity(gamePlayerData) {
    let success = false;
    const targets = [ ...Room.BED_IDS, ...Room.AMENITY_IDS ];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (!roomId) {
            return;
        }
        if (targets.includes(roomId) &&
            !isRoomActivated(gamePlayerData, stationIndex) &&
            canIActivateThisRoom(gamePlayerData, stationIndex)) {
            success = true;
        }
    });
    return success;
}


export function canIActivateARandomActionRoom(gamePlayerData) {
    let success = false;
    const targets = [ ...Room.ACTION_ROOMS_WITH_RANDOM ];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (!roomId) {
            return;
        }
        if (targets.includes(roomId) &&
            !isRoomActivated(gamePlayerData, stationIndex) &&
            canIActivateThisRoom(gamePlayerData, stationIndex)) {
            success = true;
        }
    });
    return success;
}


export function activateARandomActionRoom(gamePlayerController) {
    const matchingActionRoomTypes = Room.ACTION_ROOMS_WITH_RANDOM;
    let success = false;
    for (const [stationIndex, roomId] of gamePlayerController.gamePlayerData.station.entries()) {
        if (roomId && matchingActionRoomTypes.includes(roomId) &&
            !isRoomActivated(gamePlayerController.gamePlayerData, stationIndex) &&
            canIActivateThisRoom(gamePlayerController.gamePlayerData, stationIndex)
        ){
            gamePlayerController.gamePlayerApi.toggleActivation(stationIndex);
            success = true;
            break;
        }
    }
    return success;
}


// Research inventory cap raised 6 -> 12 (2026-06-02). Mirror of
// GamePlayer.first_available_storage_destination in games/models.py.
// The manual imposes no storage limit; 12 is the practical ceiling.
export function firstAvailableStorageDestination(gamePlayerData) {
    let storageIndex = gamePlayerData.storage.indexOf(null);
    if (0 <= storageIndex && storageIndex < 12) return storageIndex;
    let storageItemCount = gamePlayerData.storage.length;
    if (storageItemCount === 0) return 0;
    if (storageItemCount < 12) return storageItemCount;
    return null;
}


export function availableRandomActions(gamePlayerData) {
    let available = [];
    gamePlayerData.station.forEach((roomId, stationIndex) => {
        if (!roomId) {
            return;
        }
        if (Room.ACTION_ROOMS_WITH_RANDOM.includes(roomId) &&
            isRoomActivated(gamePlayerData, stationIndex) &&
            !gamePlayerData.randoms_used_this_round.includes(stationIndex)) {
            available.push(stationIndex);
        }
    });
    return available;
}

